import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface GmailRequestImpl {
    readonly gmail_service_account_key: unknown;
    readonly gmail_secret_path: string;
    readonly gmail_client_id: string;
    readonly gmail_project_id: string;
}
interface GmailCreateInputRequest {
    readonly gmail_service_account_key: unknown;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly name: string;
    readonly gmail_secret_path: string;
    readonly gmail_client_id: string;
    readonly gmail_project_id: string;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: GmailRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.gmail.api.GmailResource/gmail/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Gmail input
 */
export function create(JSONbody: GmailCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.gmail.api.GmailResource/gmail/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
